<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{$t('menuGroupManage.queryCondition')}}</span>
      </div>
        <div class="">
        <el-form :inline="true" :model="menuGroupManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input 
                v-model="menuGroupManageInfo.conditions.name" 
                :placeholder="$t('menuGroupManage.enterMenuGroupName')">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select 
                v-model="menuGroupManageInfo.conditions.label" 
                style="width:100%"
                :placeholder="$t('menuGroupManage.selectLabel')">
                <el-option value="" :label="$t('menuGroupManage.selectLabel')"></el-option>
                <el-option value="HOT" label="HOT"></el-option>
                <el-option value="TOP" label="TOP"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select 
                v-model="menuGroupManageInfo.conditions.storeType" 
                style="width:100%"
                :placeholder="$t('menuGroupManage.selectStoreType')">
                <el-option value="" :label="$t('menuGroupManage.selectStoreType')"></el-option>
                <el-option value="800900000001" :label="$t('menuGroupManage.operationTeam')"></el-option>
                <el-option value="800900000005" :label="$t('menuGroupManage.merchant')"></el-option>
                <el-option value="800900000000" :label="$t('menuGroupManage.developmentTeam')"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryMenuGroupMethod()">
              {{$t('menuGroupManage.query')}}
            </el-button>
            <el-button type="primary" size="small" @click="_resetMenuGroupMethod()">
              {{$t('menuGroupManage.reset')}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{$t('menuGroupManage.menuGroup')}}</span>
        <el-button 
          type="primary" 
          size="small" 
          style="float: right;"
          @click="_openAddMenuGroupModal()">
          <i class="el-icon-plus"></i>{{$t('menuGroupManage.add')}}
        </el-button>
      </div>
      <div class="">
        <el-table
          :data="menuGroupManageInfo.menuGroups"
          style="width: 100%">
          <el-table-column
            prop="gId"
            :label="$t('menuGroupManage.menuGroupId')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('menuGroupManage.menuGroupName')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="groupType"
            :label="$t('menuGroupManage.menuGroupType')"
            align="center"
            :formatter="formatGroupType">
          </el-table-column>
          <el-table-column
            prop="storeType"
            :label="$t('menuGroupManage.storeType')"
            align="center"
            :formatter="formatStoreType">
          </el-table-column>
          <el-table-column
            prop="icon"
            :label="$t('menuGroupManage.icon')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="label"
            :label="$t('menuGroupManage.label')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="seq"
            :label="$t('menuGroupManage.sequence')"
            align="center">
          </el-table-column>
          <el-table-column
            :label="$t('menuGroupManage.operation')"
            align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="_openEditMenuGroupModel(scope.row)">
                {{$t('menuGroupManage.edit')}}
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="_openDeleteMenuGroupModel(scope.row)">
                {{$t('menuGroupManage.delete')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <add-menu-group ref="addMenuGroup"></add-menu-group>
    <edit-menu-group ref="editMenuGroup"></edit-menu-group>
    <delete-menu-group ref="deleteMenuGroup"></delete-menu-group>
  </div>
</template>

<script>
import { listMenuGroups } from '@/api/dev/menuGroupApi'
import AddMenuGroup from '@/components/dev/addMenuGroup/addMenuGroup'
import EditMenuGroup from '@/components/dev/editMenuGroup/editMenuGroup'
import DeleteMenuGroup from '@/components/dev/deleteMenuGroup/deleteMenuGroup'

export default {
  name: 'MenuGroupManage',
  components: {
    AddMenuGroup,
    EditMenuGroup,
    DeleteMenuGroup
  },
  data() {
    return {
      menuGroupManageInfo: {
        menuGroups: [],
        total: 0,
        records: 1,
        conditions: {
          gId: '',
          name: '',
          icon: '',
          label: '',
          storeType: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listMenuGroups(this.currentPage, this.pageSize)
  },
  methods: {
    async _listMenuGroups(page, rows) {
      try {
        const params = {
          ...this.menuGroupManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listMenuGroups(params)
        this.menuGroupManageInfo.menuGroups = res.data
        this.menuGroupManageInfo.total = res.total
        this.menuGroupManageInfo.records = res.records
      } catch (error) {
        console.error('获取菜单组列表失败:', error)
      }
    },
    _openAddMenuGroupModal() {
      this.$refs.addMenuGroup.open()
    },
    _openEditMenuGroupModel(row) {
      this.$refs.editMenuGroup.open(row)
    },
    _openDeleteMenuGroupModel(row) {
      this.$refs.deleteMenuGroup.open(row)
    },
    _queryMenuGroupMethod() {
      this.currentPage = 1
      this._listMenuGroups(this.currentPage, this.pageSize)
    },
    _resetMenuGroupMethod() {
      this.menuGroupManageInfo.conditions = {
        gId: '',
        name: '',
        icon: '',
        label: '',
        storeType: ''
      }
      this._listMenuGroups(this.currentPage, this.pageSize)
    },
    formatGroupType(row) {
      return row.groupType === 'P_WEB' ? 'web菜单' : 'App菜单'
    },
    formatStoreType(row) {
      if (row.storeType === '800900000001') {
        return this.$t('menuGroupManage.operationTeam')
      } else if (row.storeType === '800900000005') {
        return this.$t('menuGroupManage.merchant')
      } else if (row.storeType === '800900000000') {
        return this.$t('menuGroupManage.developmentTeam')
      } else {
        return this.$t('menuGroupManage.unknown')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listMenuGroups(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-bottom: 20px;
}
</style>